export const ProfileData = [
  { key: "Name", value: "The Lapuacase" },
  { key: "Language", value: "🇯🇵(Native) / 🇺🇸🇬🇧(Learner)" },
];

// NOTE 最終的にはソースではなくyamlとかで管理するようにしたい
